import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TPVServices } from "../../services";
import { Globals } from '../../../../globals';

/**
 * Generated class for the TpvTicketMenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-tpv-ticket-menu',
    templateUrl: 'tpv-ticket-menu.html',
})
export class TpvTicketMenuPage {



    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public tpvServices: TPVServices,
        public globals: Globals) {
    }

    styleHeight() {
        //get height screen
        //var height = window.innerHeight - 75; //70 es la capcalera
        //height = height / 2; Comentem al treure els addons
        let styles = {
            //'height': height + 'px',
            'height': 'auto',
            //'overflow': 'scroll',
            'padding-bottom': '20px',
        };
        return styles;
    }

    styleAddon() {
        //get height screen
        var height = window.innerHeight - 75; //70 es la capcalera
        height = height / 2; //Div sections
        height = height - 130; //Div categories

        height = 0; //eliminem

        let styles = {
            'height': height + 'px',
            'width': 100 + '%',
            //'background-image': 'linear-gradient(89deg,#ff7a59,#f2547d)',
            'color': '#fff',
            'border-radius': '5px',
            'font-weight': 'bold',
            'overflow': 'hidden',
            'line-height': height + 'px',
            'text-align': 'center',
        };
        return styles;
    }

    back() {
        this.navCtrl.pop();
    }

    changeCategorie(categorie) {
        this.tpvServices.selected_tag = 'all';
        this.tpvServices.section_select = categorie;
        if (this.globals.tour != '') {
            this.globals.tour_step_user = 4;
        }
    }

    changeSelectTag(tag) {
        this.tpvServices.sendTagDish(tag);
        this.tpvServices.selected_tag = tag;
    }
    changeSelectTagProduct(tag) {
        this.tpvServices.sendTagProduct(tag);
        this.tpvServices.selected_tag = tag;
    }

}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-ticket/tpv-ticket-menu/tpv-ticket-menu.ts